<template>
  <div class="footer-content">
    <div class="left">
      <img src="/img/ycx/logo2.png" alt="">
      <span>相关服务主体：深圳云创猩数字科技有限公司
      </span>
      <span>深圳云创猩数字科技有限公司ICP备案/许可证号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          rel="noopener noreferrer">粤ICP备2024340740号</a></span>
    </div>
    <div class="right">
      <span class="title">联系我们</span>
      <span>营销获客微信扫码联系云创猩</span>
      <img src="/img/ycx/qrcode.png" alt="">
      <div>
        <span>咨询热线：</span>
        <span class="tel">189-2528-7266</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style scoped lang="scss">
.footer-content {
  padding: 2.5rem 11.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .left {
    display: flex;
    flex-direction: column;

    img {
      width: 6rem;
      margin-bottom: 1.8rem;
    }

    span {
      color: #0B0909;
      opacity: 0.5;
      font-size: 0.6rem;
      line-height: 20px;

      a {
        color: #0B0909;
        font-size: 0.6rem;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    img {
      width: 4rem;
      margin: 0.8rem 0 0.5rem 0;
    }

    span {
      color: #0B0909;
      opacity: 0.5;
      font-size: 0.6rem;
      line-height: 20px;
    }

    .title {
      font-size: 0.65rem;
      opacity: 0.8;
      font-weight: bold;
    }

    .tel {
      font-size: 1rem;
      font-weight: bold;
      opacity: 1;
    }
  }
}
</style>